import Button from "ab-button";
import Text from "ab-text";

import { useModalContext } from "ab-context-modal";

const LinkItem = ({ title, description, link }) => {
  const [stateModal, dispatchMdoal] = useModalContext();
  const { setShowModal } = dispatchMdoal;

  return (
    <>
      <div className="item">
        <div className="detail">
          <div>
            <Text element="h2">{title}</Text>
            <Text element="span" className="title">
              {description}
            </Text>
          </div>

          <div className="mobile">
            <Button type="mas" href={link} />
          </div>
          <div className="web">
            <Button type="mas" onClick={() => setShowModal(true, link)} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LinkItem;
